import { Link } from "react-router-dom";

export const STAGE_STYLE = {
  done: "bg-emerald-500 border-emerald-500 text-white",
  running: "bg-sky-500 border-sky-500 text-white animate-pulse",
  waiting: "bg-amber-400 border-amber-400 text-white",
  failed: "bg-red-500 border-red-500 text-white",
  not_started: "bg-white border-zinc-300 text-zinc-400",
};
export const DOT = { done: "bg-emerald-500", running: "bg-sky-500 animate-pulse", waiting: "bg-amber-400", failed: "bg-red-500", not_started: "bg-zinc-300", idle: "bg-zinc-300" };
export const STATUS_WORD = { done: "done", running: "running", waiting: "waiting on you", failed: "failed", not_started: "not started" };

export function Stepper({ certId, stages, current, compact = false }) {
  return (
    <div className={`overflow-x-auto ${compact ? "" : "-mx-1 px-1"}`} data-testid={compact ? `stepper-compact-${certId}` : "stage-stepper"}>
      <ol className={`flex items-start ${compact ? "gap-1" : "gap-2 min-w-[640px]"}`}>
        {stages.map((s, i) => {
          const isCur = s.key === current;
          const circle = compact ? "h-2.5 w-2.5" : isCur ? "h-10 w-10 text-sm ring-4 ring-sky-100" : "h-8 w-8 text-xs";
          return (
            <li key={s.key} className={`flex ${compact ? "" : "flex-1"} items-start`}>
              <Link to={`/admin/certs/${certId}/stage/${s.key}`} className={`group flex ${compact ? "" : "flex-1 flex-col items-center text-center"}`}
                    data-testid={compact ? undefined : `stepper-stage-${s.key}`} title={`${s.n} ${s.name} · ${STATUS_WORD[s.status]}`}>
                <span className={`inline-flex items-center justify-center rounded-full border-2 font-bold transition-transform duration-150 group-hover:scale-105 ${circle} ${STAGE_STYLE[s.status]}`}>
                  {compact ? "" : s.n}
                </span>
                {!compact && (
                  <>
                    <span className={`mt-1.5 text-xs font-semibold ${isCur ? "text-zinc-900" : "text-zinc-600"}`}>{s.name}</span>
                    <span className="text-[10px] uppercase tracking-wide text-zinc-400">{s.owner}</span>
                  </>
                )}
              </Link>
              {!compact && i < stages.length - 1 && <span className={`mt-4 h-0.5 w-6 shrink-0 ${s.status === "done" ? "bg-emerald-400" : "bg-zinc-200"}`} />}
            </li>
          );
        })}
      </ol>
    </div>
  );
}
